<div class="div-action-top">
  <div class="left">
    <div class="form-filter ant-form ant-form-inline">
      <input style="width: 200px" [(ngModel)]="searchText" (ngModelChange)="doSearch()" nz-input
             placeholder="Tìm mã phiếu"/>
      <button *ngIf="isMaster" nzSize="default" nz-button nzType="primary" class="btn-add-asset" type="button" (click)="showModalAdd()">
        <em class="fas fa-plus fa-fw"></em> Thêm phiếu xuất điều chuyển
      </button>
      <button *ngIf="!isMaster" nzSize="default" nz-button nzType="primary" class="btn-add-asset" type="button" (click)="showModalAdd()">
        <em class="fas fa-plus fa-fw"></em> Thêm phiếu xuất kho
      </button>
    </div>
  </div>
</div>

<!-- Hiển thị thông tin phiếu -->
<div class="data-table">
  <nz-table #basicTable [nzData]="filterData" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            [nzPageSizeOptions]="pageSize" [nzPageSize]="defaultPage" nzSize="small" nzShowSizeChanger
            [nzShowTotal]="rangeTemplate" [nzLoading]="loading"
            [nzScroll]="{x: '1000px'}"
  >
    <thead>
    <tr>
      <th nzShowCheckbox nzLeft="0px" nzWidth="50px" [(nzChecked)]="isAllDisplayDataChecked"
          [nzIndeterminate]="isIndeterminate" (nzCheckedChange)="checkAllRow($event)"></th>
      <th nzLeft class="text-nowrap" width="50px">#</th>
      <th nzLeft class="text-nowrap" width="150px">Mã phiếu</th>
      <th class="text-nowrap" width="200px">Mô tả phiếu</th>
      <th class="text-nowrap" width="120px">Đối tượng nhận</th>
      <th class="text-nowrap" width="150px"nzFormat="dd/MM/yyyy HH:mm">Thời gian xuất</th>
      <th class="text-nowrap" width="80px">Người xuất</th>
      <!-- <th class="text-nowrap">Tiền thanh toán</th>
      <th class="text-nowrap">Mã HĐ thanh toán</th> -->
      <th nzRight class="text-nowrap" width="90px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of basicTable.data;let i = index;">
      <td nzLeft nzShowCheckbox [(nzChecked)]="mapOfCheckedId[data.id]" (nzCheckedChange)="refreshStatus()" nzLeft="0px"
          nzWidth="50px"></td>
      <td nzLeft class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td nzLeft class="">{{data.code}}</td>
      <td class="">{{data.description}}</td>
      <td class="text-nowrap">
        <strong>{{data.toWareHouse ? data.toWareHouse.name : data.receiveType === 1 ? 'Máy XN' : 'Khác'}}</strong>
      </td>
      <!--<td class="">{{ data.recipient }}</td>-->
      <td class="text-nowrap">{{ data.exportDate | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ data.user.fullname }}</td>
      <td nzRight class="text-nowrap" width="90px">
        <button nz-button nzSize="small" nzType="danger" class="btn-right" (click)="showConfirm(data.id)"
                *ngIf="checkDelete"><span class="fa fa-times fa-fw"></span>
        </button>
        <button nz-button nzSize="small" nzType="primary" class="btn-right" (click)="showDetails(data)"
                *ngIf="checkDetails"><span class="fa fa-info fa-fw"></span>
        </button>
        <button *ngIf="data.status == 1" nz-button nzSize="small" nzType="default" class="btn-right" (click)="showModalUpdate(data)"
              ><span class="fa fa-edit fa-fw"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
  </ng-template>
</div>

<!-- Thêm, sửa phiếu xuất -->
<nz-modal nzWidth="1200px" [(nzVisible)]="isVisibleAdd" nzClosable="false" [nzTitle]="title1" nzMaskClosable="false">
  <ng-template #title1>
    <span *ngIf="isMaster">Thông tin phiếu xuất điều chuyển</span> 
    <span *ngIf="!isMaster">Thông tin phiếu xuất kho</span> 
    <div class="pull-right icon-close">
      <em (click)="handleCancel()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>

  <div *ngIf="enableEdit">
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Mã phiếu</label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="isEdit || viewOnly" [(ngModel)]="selectedData.code" nz-input placeholder="Mã sẽ tự thêm nếu ô bỏ trống .."/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Mô tả phiếu<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <input [disabled]="viewOnly" nz-input placeholder="Mô tả phiếu" [(ngModel)]="selectedData.description"/>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="selectedWarehouse && selectedWarehouse.inverseParent.length">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Kho nhận<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <nz-select [disabled]="viewOnly" nzShowSearch nzAllowClear nzPlaceHolder="Chọn kho nhận" [(ngModel)]="selectedData.toWareHouseId" style="width: 100%">
          <nz-option *ngFor="let item of selectedWarehouse.inverseParent" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Người giao<em
        class="fa fa-asterisk required"></em></label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="viewOnly" id="name2" nz-input placeholder="Nhập tên người giao .." [(ngModel)]="selectedData.importerName"/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Người nhận<em
        class="fa fa-asterisk required"></em></label>
      <nz-form-control [nzSpan]="16" style="position: relative;">
        <input [disabled]="viewOnly" id="name1" nz-input placeholder="Nhập tên người nhận .." [(ngModel)]="selectedData.receiverName"/>
      </nz-form-control>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="selectedWarehouse && !selectedWarehouse.inverseParent.length">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Loại đối tượng nhận<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <nz-select [disabled]="viewOnly" nzShowSearch nzAllowClear nzPlaceHolder="Chọn máy xét nghiệm" [(ngModel)]="selectedData.receiveType" style="width: 100%">
          <nz-option nzLabel="Máy xét nghiệm" [nzValue]="1"></nz-option>
          <nz-option nzLabel="Khác" [nzValue]="2"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="selectedWarehouse && !selectedWarehouse.inverseParent.length">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Đối tượng nhận<em
        class="fa fa-asterisk required"></em></label>
      <div nz-col [nzSpan]="16">
        <nz-select [disabled]="viewOnly" *ngIf="selectedData.receiveType === 1" nzShowSearch nzAllowClear nzPlaceHolder="Chọn đối tượng nhận" [(ngModel)]="selectedData.recipient" style="width: 100%">
          <nz-option *ngFor="let m of machines" [nzLabel]="m.name" [nzValue]="m.name"></nz-option>
        </nz-select>
        <input [disabled]="viewOnly" nz-input *ngIf="selectedData.receiveType === 2" placeholder="Tên đối tượng" [(ngModel)]="selectedData.recipient"/>
      </div>
    </div>
    <div class="input-wrap nz-row row-width">
      <label class="title-detail text-text" nz-col [nzSpan]="4">Scan barcode</label>
      <div nz-col [nzSpan]="16">
        <nz-switch [disabled]="viewOnly" nzSize="default" [(ngModel)]="selectedData.scanBarcode"></nz-switch>
      </div>
    </div>
    <div class="input-wrap nz-row row-width" *ngIf="!viewOnly">
      <label class="title-detail text-text" nz-col [nzSpan]="4">&nbsp;</label>
      <div nz-col [nzSpan]="16">
        <input [disabled]="viewOnly" (ngModelChange)="handleBarcode($event)" style="width: 300px;" *ngIf="selectedData.scanBarcode" nz-input placeholder="Paste code here" type="text" [(ngModel)]="selectedData.parcelDetailCode"/>
      </div>
    </div>
  </div>
  <!-- Thông tin chi tiết phiếu xuất -->
  <div class="div-action" *ngIf="!viewOnly">
    <button *ngIf="!selectedData.scanBarcode" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
            (click)="addDetailInput()">
      <em class="fas fa-plus fa-fw"></em>
    </button>
    <div class="clearfix"></div>
  </div>
  <button *ngIf="viewOnly" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
          (click)="exportPDF()">
    <em class="fas fa-file-pdf fa-fw"></em>
    Xem trước
  </button>
  <nz-table [nzData]="datas" [nzShowPagination]="false"  #spreadsheet  [nzScroll]="{ y: '250px' }" id="detailTable">
    <thead>
    <tr>
      <th nzWidth="80px"></th>
      <th nzWidth="80px">STT</th>
      <th nzWidth="120px">Barcode<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="180px">Mã - Tên hóa chất<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Code NSX<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Hãng/Nước SX<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Số lô<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Hạn sử dụng<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Seri<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="150px">Quy cách đóng gói<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="100px">Đơn vị<em class="fa fa-asterisk required"></em></th>
      <th nzWidth="120px">Số lượng<em class="fa fa-asterisk required"></em></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of selectedData.warehouseExportDetails; let i = index">
      <td>
        <button *ngIf="!viewOnly" nzSize="small" nz-button nzType="danger" class="button-update btn-right" (click)="deleteDetail(item)">Xóa
        </button>
      </td>
      <td>
        {{ i + 1 }}
      </td>
      <td>
        {{item.parcelDetailCode}}
      </td>
      <td>
        {{item.chemical.name}}
      </td>
      <td>
        {{item.manufacturerCode}}
      </td>
      <td>
        {{item.madeIn}}
      </td>
      <td>
        {{item.batchNumber}}
      </td>
      <td>
        {{item.expiredDate | date: 'dd-MM-yyyy'}}
      </td>
      <td>
        {{item.serialNumber}}
      </td>
      <td>
        {{ item.chemical?.packingQuantity }} {{ item.unitTypeText }}/{{ item.chemical?.packing }}
      </td>
      <td>
        {{item.unitTypeText}}
      </td>
      <td>
          <input [disabled]="viewOnly || isMaster" nz-input nz-tooltip tabIndex [index]=" i * 6 + 11" [(ngModel)]="item.amount">
      </td>
    </tr>
    </tbody>
  </nz-table>

  <div *nzModalFooter>
    <button nz-button (click)="handleCancel()">{{'cancel' | translate }}</button>
    <button [nzLoading]="loadingButton" nz-button *ngIf="!viewOnly" nzType="primary" (click)="handleOk()" class="button-submit">Lưu nháp</button>
    <button *ngIf="selectedData.status !== 2" [disabled]="disableComplete" nz-button nzType="primary" (click)="handleComplete()" class="button-submit">Hoàn thành</button>
  </div>
</nz-modal>
